module.exports = __webpack_public_path__ + "static/img/activity4.1df9fa3.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/activity4.png
// module id = nNx2
// module chunks = 7